<template>
  <div class="warpper">
    <template v-if="lookNews">
      <div class="header">
        <img
          class="headerImg"
          :src="require('@/assets/recycling/news/newsLogo.png')"
          alt=""
        />
        <el-input
          @keyup.enter.native="handleSearch"
          @change="handleSearch"
          clearable
          placeholder="请输入关键字"
          v-model="form.keywords"
          class="input-with-select"
        >
          <el-button
            @click="handleSearch"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
      <div class="content">
        <template v-if="!showNewsList">
          <el-row>
            <template v-for="item in newData">
              <el-col :span="24">
                <div>
                  <!--首页列表-->
                  <news-list
                    @lookMore="lookMore"
                    @lookMyEyes="lookMyEyes"
                    class="newsList"
                    :newData="item"
                  />
                </div>
              </el-col>
            </template>
          </el-row>
        </template>
        <!--查看更多组件-->
        <news-info
          v-else
          @goBack="goBack"
          :choseNewTypeInfo="choseNewTypeInfo"
          @lookMyEyes="lookMyEyes"
          :choseTypeData="choseTypeData"
        />
      </div>
    </template>
    <!--新闻详情-->
    <new-content
      @goParent="goParent"
      @goSecond="goSecond"
      v-else
      :newsContentInfo="newsContentInfo"
    />
    <bottom-url />
  </div>
</template>

<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import MinimarkDown from '@/components/comments/minimarkDown.vue';
import newsList from './component/newsList.vue';
import newsInfo from './component/newsInfo.vue';
import newContent from './component/newContent.vue';
import { scrollTop } from '@/util/scrollTop';
import { getPunishmentList, getPunishmentPage } from '@/API/news/news.js';
export default {
  name: 'index',
  components: { MinimarkDown, BottomUrl, newsList, newsInfo, newContent },
  data() {
    return {
      showNewsList: false,
      input3: '',
      content: '',
      htmlOutput: '',
      lookNews: true,
      breadList: [],
      newData: [],
      choseTypeData: [],
      choseNewTypeInfo: {},
      choseNewType: undefined,
      newsContentInfo: '',
      form: {
        keywords: '',
      },
    };
  },
  watch: {
    '$store.state.routerClickStatus': {
      handler: function (value) {
        this.moveHome();
      },
    },
    '$store.state.news.formKeyWords': {
      handler: function (value) {
        if (this.lookNews && !this.showNewsList) {
          this.getArticleList();
        }
      },
    },
    // 添加对路由参数的监听
    '$route.params': {
      handler(params) {
        if (params && params.info && params.info.newsId) {
          this.handleRouteParams(params.info);
        }
      },
      immediate: true, // 立即执行一次
    },
  },
  mounted() {
    let params = this.$route.params;
    
    // 新增：检查是否有从全局搜索跳转过来的关键词
    const globalKeyword = sessionStorage.getItem('search_keyword_from_global');
    if (globalKeyword) {
      this.form.keywords = globalKeyword;
      // 清除标记，避免刷新页面重复搜索
      sessionStorage.removeItem('search_keyword_from_global');
      // 执行搜索
      this.handleSearch();
    } else {
      // 原有逻辑：如果没有外部跳转词，则正常加载列表
      this.getArticleList();
    }

    if (params && params.info && params.info.newsId) {
      this.lookMyEyes(params.info);
    }
  },
  methods: {
    // 新增方法：处理路由参数
    handleRouteParams(info) {
      // 查找对应的新闻内容
      const findNews = (data) => {
        for (const category of data) {
          for (const article of category.articles) {
            if (article.id === info.id) {
              return article;
            }
          }
        }
        return null;
      };

      const newsContent = findNews(this.newData);
      if (newsContent) {
        this.lookMyEyes(newsContent);
      }
    },
    getArticleList() {
      getPunishmentList(this.form).then((res) => {
        if (res.code === 200) {
          res.data.forEach((item) => {
            if (item.articles.length > 10) {
              item.articles.length = 10;
            }
          });
          this.newData = res.data;
          console.log(res.data, ' this.newData this.newData');
        }
      });
    },
    lookMyEyes(contentInfo) {
      this.lookNews = false;
      this.newsContentInfo = contentInfo;
    },
    lookMore(item) {
      console.log(item, 'itemitemitem');
      this.choseNewType = item.id;
      this.choseNewTypeInfo = item;
      this.showNewsList = true;
    },
    // 新闻列表返回上级
    goBack() {
      this.showNewsList = false;
      this.getArticleList();
    },
    // 新闻详情返回上级
    goParent() {
      this.lookNews = true;
      this.showNewsList = false;
      this.getArticleList();
    },
    goSecond(info) {
      // 重新拼装查看更多组件需要传递的关键参数
      this.choseNewTypeInfo = {
        id: info.parentId[0] || null,
      };
      // 获取行业类型名称
      this.newData.forEach((item) => {
        if (item.id == info.parentId[0]) {
          this.choseNewTypeInfo.name = item.name;
        }
      });
      this.showNewsList = true;
      this.lookNews = true;
    },
    // 点击banner栏，返回当前目录首页并置顶
    moveHome() {
      this.showNewsList = false;
      this.lookNews = true;
      this.getArticleList();
      scrollTop();
    },
    handleSearch() {
      this.$store.commit('news/changeFormKeyWords', this.form.keywords);
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .header{
    width: 100% !important;
    height: 150px !important;
  }
  .headerImg{
    height: 150px !important;
  }
  .input-with-select{
    width: 90% !important;
    left: 5% !important;
    top: unset !important;
    bottom: 30% !important;
  }
  .content{
    width: 100% !important;
  }
  .newsList{
    padding: 0 10px;
  }
}
.warpper {
  width: 100%;
  height: 100%;
  .header {
    height: 315px;
    position: relative;
    width: 1400px;
    margin: 0px auto 10px auto;
    //background: url('~@/assets/recycling/news/newsLogo.png') no-repeat center;
    //background-size: contain;
    .input-with-select {
      position: absolute;
      left: 30%;
      top: 40%;
      width: 40%;
    }
    .headerImg {
      height: 300px;
      width: 100%;
      position: absolute;
      //border-radius: 8px;
      left: 0;
      top: 0;
    }
    .headerTitle {
      position: absolute;
      width: 100%;
      text-align: center;
      top: 10%;
      left: 0;
      font-size: 40px;
      font-weight: 700;
      z-index: 99;
    }
  }
  .news_warpper {
    width: 100%;
    padding: 0 120px 20px 120px;
    margin: 0 0 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .newsBox {
      width: 47.5%;
      background-color: #edf2f7;
      border-radius: 3px;
      height: fit-content;
      margin-bottom: 100px;
      .newsCard_title {
        display: flex;
        align-items: center;
        padding: 10px;
        .newsCard_title_type {
          font-size: 16px;
          font-weight: 700;
        }
        .newsCard_title_type_point {
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background-color: #1da1f2;
          margin: 0 10px;
        }
        .newsCard_title_totle {
          font-size: 14px;
          .newsCard_title_totle_nums {
            color: #409eff;
          }
        }
      }
      .newsCard {
        position: relative;
        width: 100%;
        max-height: 700px;
        cursor: pointer;
        .newsCard_mini {
          float: left;
          margin: 6px;
          width: 48.4%;
          height: 31.3%;
          border-radius: 3px;
          background-color: #ffffff;
          transition: 300ms;
          .newsCard_mini_img {
            width: 100%;
            height: 55%;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .newsCard_mini_content {
            width: 100%;
            height: 45%;
            padding: 10px;
            .newsCard_mini_content_name {
              width: 100%;
              height: 60%;
              p:nth-child(1) {
                font-size: 14px;
                height: 18px;
                line-height: 18px;
                font-weight: 700;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              p:last-child {
                font-size: 12px;
                color: #8c939d;
              }
            }
            .newsCard_mini_content_times {
              width: 100%;
              height: 40%;
              font-size: 12px;
              display: flex;
              align-items: center;
              color: #8c939d;
            }
          }
        }
        .newsCard_mini:hover {
          scale: 1.02;
          box-shadow: 0px 3px 10px rgba(143, 143, 143, 0.8);
        }
      }
    }
  }
  .moreNewsBox {
    width: 100%;
    overflow-y: scroll;
    display: flex;
    justify-content: center;
    .moreNewsBox_warpper {
      width: 70%;
      background-color: #edf2f7;
      margin-bottom: 100px;
      .newsCard_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        .newsCard_title_type {
          font-size: 16px;
          font-weight: 700;
        }
        .newsCard_title_type_point {
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background-color: #1da1f2;
          margin: 0 10px;
        }
        .newsCard_title_totle {
          font-size: 14px;
          .newsCard_title_totle_nums {
            color: #409eff;
          }
        }
        .moreType {
          display: flex;
          align-items: center;
        }
      }
      .newsCard {
        position: relative;
        width: 100%;
        height: calc(100% - 120px);
        cursor: pointer;
        .newsCard_mini {
          float: left;
          margin: 6px;
          width: 32.4%;
          height: 47.3%;
          border-radius: 3px;
          background-color: #ffffff;
          .newsCard_mini_img {
            width: 100%;
            height: 55%;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .newsCard_mini_content {
            width: 100%;
            height: 45%;
            padding: 10px;
            .newsCard_mini_content_name {
              width: 100%;
              height: 60%;
              p:nth-child(1) {
                font-size: 14px;
                height: 18px;
                line-height: 18px;
                font-weight: 700;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              p:last-child {
                font-size: 12px;
                color: #8c939d;
              }
            }
            .newsCard_mini_content_times {
              width: 100%;
              height: 40%;
              font-size: 12px;
              display: flex;
              align-items: center;
              color: #8c939d;
            }
          }
        }
      }
    }
  }
  .pagination {
    width: 100%;
    display: flex;
    justify-content: end;
    padding-right: 30px;
  }
  .showMore {
    display: flex;
    justify-content: end;
    padding-right: 20px;
    font-size: 14px;
    align-items: center;
    margin: 10px 0;
    span {
      cursor: pointer;
      color: #000000;
      font-weight: 500;
    }
    span:hover {
      color: #8c939d;
    }
  }
  .newsInfo {
    .newsInfo_header {
      padding: 20px;
      .newsInfo_header_bread {
        color: #2c3e50;
        font-weight: 600;
        cursor: pointer;
      }
      .newsInfo_header_bread:hover {
        color: #1290e5;
      }
    }
    .newsInfo_warpper {
      display: flex;
      justify-content: center;
      height: 100%;
      margin-bottom: 100px;
      .newsInfo_content {
        width: 56%;
        background: #ffffff;
        .newsInfo_content_header {
          display: flex;
          justify-content: center;
          padding: 50px 0 30px 0;
          .newsInfo_content_header_name {
            width: 80%;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .newsInfo_content_instraction {
          display: flex;
          justify-content: center;
          .newsInfo_content_instraction_left,
          .newsInfo_content_instraction_right {
            width: 20%;
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #606266;
          }
        }
        .newsInfo_content_text {
          padding: 0 100px;
          margin-top: 30px;
          margin-bottom: 100px;
          font-family:
            'Georgia', 'Times New Roman', serif; /* 适合新闻阅读的字体 */
          font-size: 16px; /* 16-18px 基础大小 */
          line-height: 1.6; /* 良好的行间距 */
          color: #333; /* 深灰色更易阅读 */
          text-align: justify; /* 两端对齐 */
          text-justify: inter-word; /* 单词间调整 */
          p {
            padding: 20px 0;
            text-indent: 2em;
            text-justify: inter-word; /* 单词间调整 */
          }
        }
      }
    }
  }
}
.content {
  width: 1400px;
  margin: 0 auto 50px auto;
  min-height: 29%;
}
/deep/.el-divider--horizontal {
  margin: 12px 0;
}
</style>
